// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type UnteraufgabenPromptItem } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetUnteraufgabePromptWithInserts(): (
  unteraufgabeId: string,
  kontaktId: string,
  aufgabeId: string
) => Promise<UnteraufgabenPromptItem> {
  const getAPI = useGetApi();
  return useCallback(
    async (unteraufgabeId, kontaktId, aufgabeId) =>
      (await getAPI()).auswertungUnteraufgabe.getUnteraufgabePromptWithInserts({
        unteraufgabeId,
        kontaktId,
        aufgabeId,
      }),
    [getAPI]
  );
}
